import { BaseClient } from '../BaseClient';
import { CallWindow, CallWindowList } from '../compiled-protos/call_window';
import { CallWindowServiceClient } from '../compiled-protos/call_window.client';
import { Empty } from '../compiled-protos/common';

class CallWindowClient extends BaseClient {
  self: CallWindowServiceClient;

  constructor(host: string, userID?: number) {
    super(host, userID);
    this.self = new CallWindowServiceClient(this.transport);
  }

  public async Create(req: CallWindow): Promise<CallWindow | undefined> {
    let res = CallWindow.create();
    try {
      res = await this.self.createCallWindow(req, this.getMetaData()).response;
    } catch (err) {
      console.log(err);
      return;
    }
    return res;
  }

  public async Get(req: CallWindow): Promise<CallWindow | undefined> {
    let res = CallWindow.create();
    try {
      res = await this.self.getCallWindow(req, this.getMetaData()).response;
    } catch (err) {
      console.log(err);
      return;
    }
    return res;
  }

  public async BatchGet(req: CallWindow): Promise<CallWindowList | undefined> {
    let res = CallWindowList.create();
    try {
      res = await this.self.batchGetCallWindow(req, this.getMetaData()).response;
    } catch (err) {
      console.log(err);
      return;
    }
    return res;
  }

  public async Update(req: CallWindow): Promise<CallWindow | undefined> {
    let res = CallWindow.create();
    try {
      res = await this.self.updateCallWindow(req, this.getMetaData()).response;
    } catch (err) {
      console.log(err);
      return;
    }
    return res;
  }

  public async Delete(req: CallWindow): Promise<Empty | undefined> {
    let res = Empty.create();
    try {
      res = await this.self.deleteCallWindow(req, this.getMetaData()).response;
    } catch (err) {
      console.log(err);
      return;
    }
    return res;
  }

  // Helper method to load call windows with pagination and filtering
  public loadCallWindows = async ({
    page,
    filter,
    sort,
  }: LoadCallWindowsRequest): Promise<CallWindowList> => {
    const req = CallWindow.create();
    req.pageNumber = page;

    // Apply filters
    if (filter.dayOfWeek !== undefined) {
      req.dayOfWeek = filter.dayOfWeek;
    }
    if (filter.startTime) {
      req.startTime = filter.startTime;
    }
    if (filter.endTime) {
      req.endTime = filter.endTime;
    }
    if (filter.isActive !== undefined) {
      req.isActive = filter.isActive;
    }
    if (filter.departmentId !== undefined) {
      req.departmentId = filter.departmentId;
    }

    // Apply sorting
    req.orderBy = sort.orderBy;
    req.orderDir = sort.orderDir;

    const result = await this.BatchGet(req);
    return result || CallWindowList.create();
  };
}

export { CallWindowClient, CallWindow, CallWindowList };

// Types for helper methods
export type LoadCallWindowsRequest = {
  page: number;
  filter: CallWindowFilter;
  sort: CallWindowSort;
};

export type CallWindowFilter = {
  dayOfWeek?: number;
  startTime?: string;
  endTime?: string;
  isActive?: boolean;
  departmentId?: number;
};

export type CallWindowSort = {
  orderBy: string;
  orderDir: 'ASC' | 'DESC';
}; 